import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts, Colors } from "@/theme";

const useStyles = makeStyles((theme) =>
  createStyles({
    labelText: {
      ...CommonFonts.darkFont16,
    },
  })
);

export default useStyles;
